import { createGqlQuery } from '../fetcher';
import { Organizations } from '../queries/organizations.query';
import type * as Types from '../types';

export const useOrganizationsQuery = createGqlQuery<
  Types.OrganizationsQueryVariables,
  Types.OrganizationsQuery
>(() => ['organization'], Organizations);
